import { render } from "./HeroiconsSolidMenuAlt4.vue?vue&type=template&id=e83a5438"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMenuAlt4.vue"]])

export default __exports__